import * as React from 'react';

import { IconProps } from 'bones/design-system/components/icons/Icon';

export type KnowledgeCatalogLogoProps = {
  title?: string;
} & IconProps &
  React.SVGProps<SVGSVGElement>;

export const KnowledgeCatalogLogo: React.VFC<KnowledgeCatalogLogoProps> = ({
  size,
  title,
  ...props
}) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 30 30"
    width={size}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <circle
      cx="15"
      cy="15"
      fill="#003E51"
      r="14"
      stroke="#007FA4"
      strokeWidth="0.5"
    />
    <g clipPath="url(#clip0_4949_116665)">
      <path
        clipRule="evenodd"
        d="M24.3337 6.69303C24.3057 6.2917 23.9883 5.93703 23.559 5.8717C19.807 5.26503 16.9323 5.9837 15.0003 7.9997C13.0683 5.9837 10.1937 5.26503 6.45099 5.8717C6.01233 5.94636 5.69499 6.2917 5.66699 6.69303V20.7024C5.66699 20.7677 5.66699 20.833 5.67633 20.8984C5.76033 21.3837 6.24566 21.7197 6.74966 21.6357C10.343 21.057 12.723 21.785 14.2163 23.9317C14.235 23.9504 14.2443 23.969 14.263 23.997C14.2817 24.0157 14.3003 24.0344 14.319 24.0624L14.3283 24.0717C14.347 24.0904 14.3657 24.109 14.3937 24.1277C14.4497 24.1744 14.515 24.2117 14.5897 24.249C14.599 24.249 14.599 24.2584 14.6083 24.2584C14.6363 24.2677 14.6737 24.2864 14.7017 24.2957C14.711 24.2957 14.7203 24.305 14.739 24.305C14.767 24.3144 14.8043 24.3237 14.8323 24.3237C14.8417 24.3237 14.851 24.3237 14.8697 24.333C14.9163 24.333 14.9537 24.333 15.0003 24.333C15.0377 24.333 15.0843 24.333 15.1217 24.3237C15.131 24.3237 15.1497 24.3237 15.159 24.3144C15.187 24.305 15.215 24.305 15.2523 24.2957C15.2617 24.2957 15.2803 24.2864 15.2897 24.2864C15.3177 24.277 15.355 24.2677 15.383 24.249C15.3923 24.249 15.4017 24.2397 15.411 24.2397C15.4763 24.2117 15.5323 24.1744 15.5883 24.137C15.5977 24.137 15.5977 24.1277 15.607 24.1277C15.6257 24.109 15.6443 24.0997 15.663 24.081C15.6723 24.0717 15.6817 24.0624 15.691 24.0624C15.7097 24.0437 15.719 24.0344 15.7377 24.0157C15.747 24.0064 15.7563 23.997 15.7563 23.9877C15.7657 23.969 15.775 23.9597 15.7937 23.941C17.2963 21.7944 19.667 21.057 23.2603 21.645C23.7643 21.729 24.2497 21.4024 24.3337 20.9077C24.3243 20.861 24.3337 20.8237 24.3337 20.7864V6.69303ZM14.067 21.1877C12.4057 19.965 10.2217 19.4797 7.53366 19.741V7.53303C10.5763 7.1877 12.6763 7.89703 14.067 9.72636V21.1877ZM22.467 19.7317C19.779 19.4704 17.595 19.9557 15.9337 21.1784V9.71703C17.3243 7.8877 19.4243 7.1877 22.467 7.5237V19.7317Z"
        fill="white"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_4949_116665">
        <rect
          fill="white"
          height="18.6667"
          transform="translate(5.66699 5.66663)"
          width="18.6667"
        />
      </clipPath>
    </defs>
  </svg>
);
